import { Component } from '@angular/core';
import { IMPORTS } from './_imports';

@Component({
    selector: 'loading-page',
    templateUrl: './loading-page.component.html',
    styleUrl: './loading-page.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class LoadingPageComponent {
    constructor() { }

    // #region [===== private methods =====]
    // #endregion
}
